import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { PrefabPreview2d } from '../../preview/PrefabPreview2d';
import { WebsiteState } from '@gift/website-state/store';
import { selectPrefabColumnWidth, selectPrefabPreviewMode } from '../../_redux-scene';
import { Grid, GridLayout } from '@gift/ui/components/grid/Grid';
import { Cell } from '@gift/ui/components/grid/Cell';
import { Card } from '@gift/ui/components/card/Card';

const _PrefabPickerGrid = ({
    prefabs, selectedPrefab, commit,
    mode, gridLayout, className
}: Props) => (
    <Grid gap='s' wrap {...gridLayout} className={className}>
        {prefabs.map(p => (
            <Cell key={p.id}>
                <Card onClick={() => commit(p)} active={selectedPrefab.id === p.id}>
                    <PrefabPreview2d prefab={p} mode={mode} />
                </Card>
            </Cell>
        ))}
    </Grid>
);

type Props = {
    prefabs: Prefab[],
    selectedPrefab: Prefab,
    className?: string,
    commit: (prefab: Prefab) => void,
    mode: 'full' | 'minimal',
    gridLayout: GridLayout,
};

const mapStateToProps = (state: WebsiteState) => ({
    mode: selectPrefabPreviewMode(state),
    gridLayout: selectGridLayout(state)
});

export const PrefabPickerGrid = connect(
    mapStateToProps
)(_PrefabPickerGrid);

const presets: { [K in 'small' | 'large']: GridLayout } = {
    'small': {
        xs: '1/2',
        sm: '1/3',
        lg: '1/4',
    },
    'large': {
        xs: '1/2',
        md: '1/3',
    }
};

const selectGridLayout = createSelector(
    (state: WebsiteState) => selectPrefabColumnWidth(state),
    w => presets[w]);
